import React, { useContext, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Handle, useReactFlow } from "react-flow-renderer";
import { NodesContext } from "../provider/IvrContext";
import AudioPreviewModal from "../Helpers/AudioPreviewModel";
import { toast } from 'react-toastify';

const RecordNode = ({ data, id }) => {
    const { setNodes } = useReactFlow();

    const { updateNodeData, onRemove, audioList } = useContext(NodesContext)
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [playModalOpen, setPlayModalOpen] = useState(false);

    // ✅ derive from node data
    const action = data.action || {};
    const audioId = action.id || "";
    const audioUrl = action.audio || "";
    const audioName = action.name || "";
    const recordDuration = data.record_duration || "";

    const [draftAction, setDraftAction] = useState(action);
    const [draftDuration, setDraftDuration] = useState(recordDuration);


    const updateNode = (updates) => {
        updateNodeData(id, updates);
    };

    const handleAudioChange = (e) => {
        const selected = audioList.find(
            (a) => a.id.toString() === e.target.value
        );

        if (!selected) {
            setDraftAction({});
            return;
        }

        setDraftAction({
            type: "record",
            id: selected.id,
            audio: selected.prompt_url,
            duration: selected.prompt_duration || "",
            name: selected.prompt_name
        });
    };


    const validateForm = () => {
        const newErrors = {};

        if (!draftAction?.id) {
            newErrors.audio = "Audio is required";
        }

        if (!draftDuration) {
            newErrors.record_duration = "Record duration is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSave = () => {
        if (!validateForm()) return;

        updateNode({
            action: draftAction,
            record_duration: draftDuration,
        });

        toast.success("Details updated successfully");
        setModalIsOpen(false);
    };


    const handleDurationChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value < 600) {
            setDraftDuration(value);
        }
    };

    const handleRemoveNode = () => {
        if (data.parent === "gather Node" && data.idToRemove) {
            setNodes((nodes) =>
                nodes.map((node) => {
                    if (!node.data.selectedHandles) return node;

                    const updatedHandles = { ...node.data.selectedHandles };
                    const updatedSmsData = { ...node.data.smsData }
                    delete updatedHandles[data.idToRemove];
                    if (updatedSmsData) {
                        const parts = data.idToRemove.split('-');
                        const handleIndex = parts[parts.length - 1];
                        if (handleIndex) {
                            const smsKey = `DTMF_${handleIndex}`;
                            delete updatedSmsData[smsKey]
                        }
                    }
                    return {
                        ...node,
                        data: { ...node.data, selectedHandles: updatedHandles, smsData: updatedSmsData },
                    };
                })
            );
        }
        onRemove(id)
    };

    const openModal = () => {
        setDraftAction(action);
        setDraftDuration(recordDuration);
        setErrors({});
        // setModalIsOpen(true);
        setPlayModalOpen(true);
    };

    const handleClose = () => {
        setDraftAction(action);
        setDraftDuration(recordDuration);
        setErrors({});
        setModalIsOpen(false);
    };


    return (
        <div style={{ position: "relative", width: "120px", height: "40px" }}>
            <div
                className="ivr-flow-node"
                style={{
                    position: "absolute",
                    top: "15px", // Positioned slightly down to make room for the mic handle
                    left: 0,
                    width: "100%",
                    height: "50px",
                    border: "2px solid #20c997",
                    borderRadius: "25px", // Pill Shape
                    background: "#fff",
                    zIndex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "4px 10px",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                }}
            >
                <Handle type="target" position="top" style={{
                    transform: "translateX(-50%)",
                    background: "#20c997",
                    border: "2px solid #fff",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }} />
                <Handle type="source" position="bottom" style={{
                    transform: "translateX(-50%)",
                    background: "#dc3545", // Red Color
                    border: "2px solid #fff",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }} />

                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span className="ivr-flow-node-label" style={{ fontSize: "8px", fontWeight: "bold", textTransform: "capitalize", color: "#333" }}>
                        {data.label || "Record"}
                    </span>

                    <div style={{ display: "flex", gap: "5px" }}>
                        <i
                            className="fa fa-cog ivr-flow-node-icon"
                            style={{ color: "#20c997", cursor: "pointer", fontSize: "11px" }}
                           onClick={() => setModalIsOpen(true)}
                            title="Settings"
                        />
                        <i
                            className="fa fa-trash ivr-flow-node-icon"
                            style={{ color: "#dc3545", cursor: "pointer", fontSize: "11px" }}
                            onClick={handleRemoveNode}
                            title="Delete"
                        />
                        {audioUrl && (
                            <i
                                className="fa fa-play ivr-flow-node-icon"
                                style={{ color: "#28a745", cursor: "pointer", fontSize: "11px" }}
                                title="Play audio"
                                onClick={openModal}
                            />
                        )}
                    </div>
                </div>
            </div>

            <Modal
                size="lg"
                show={modalIsOpen}
                onHide={handleClose}
                backdrop={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Record</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Select Audio</Form.Label>
                            <Form.Control
                                as="select"
                                value={draftAction?.id ? String(draftAction.id) : ""}
                                onChange={handleAudioChange}
                            >
                                <option value="">Select Audio</option>
                                {audioList.map((item) => (
                                    <option key={item.id} value={String(item.id)}>
                                        {item.prompt_name}
                                    </option>
                                ))}
                            </Form.Control>
                            {errors.audio && <Form.Text className="text-danger">{errors.audio}</Form.Text>}
                        </Form.Group>
                        <Form.Group style={{ marginTop: "20px" }}>
                            <Form.Label>Record Duration (seconds)</Form.Label>
                            <Form.Control
                                type="number"
                                min="1"
                                step="1"
                                max={600}
                                value={draftDuration}
                                onChange={handleDurationChange}
                                placeholder="Enter duration in seconds (Max 10 Mins)"
                            />
                            {errors.record_duration && (
                                <Form.Text className="text-danger">
                                    {errors.record_duration}
                                </Form.Text>
                            )}
                        </Form.Group>

                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={handleSave}>Save</Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <AudioPreviewModal
                show={playModalOpen}
                onClose={() => setPlayModalOpen(false)}
                audioUrl={audioUrl}
                title={audioName}
            />

        </div>
    );
};

export default RecordNode;
